import * as React from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import './preferences.scss';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import ConfirmationDetail from '@src/app/_global/components/confirmation/ConfirmationDetail';
interface ResponseViewProps {
  onExit: () => void;
  adminConfig: any;
  clientConfig: any;
  response: any;
  customer: any;
  directViewLogin: any;
  emailAuthOnly: any;
  redeemGiftOnly: boolean;
}

const SuccessView: React.SFC<any> = props => {
  let confMessage = '';
  if (props.redeemGiftOnly) {
    confMessage = 'You have successfully activated your gift.';
  } else {
    confMessage = 'You have successfully updated your account preferences.';
  }

  return (
    <div>
      <div className="preferences-print">
        <button
          tabIndex={0}
          className="print-page icon-blue pointer fa fa-2x fa-print print-btn no-print"
          title="Print this page."
          onClick={() =>  window.print()}
        />
      </div>
      <div className="h4 mb-2">
        <FormattedMessage
            id="preferences.heading"
            description="heading preferences"
            defaultMessage="Congratulations!"
          />
      </div>
      <div className="cancel-text mb-2">
        <FormattedMessage
            id="preferences.heading2"
            description="heading2 preferences"
            defaultMessage={confMessage}
          />
      </div>

    </div>
  );
};
const ErrorView: React.SFC<any> = props => {
  let errorMessage = 'Your transaction cannot be processed at this time. Please contact customer service for assistance.' + '\n';

  return (
    <>
      <div className="mb-1">
        <FormattedMessage
            id="preferences.heading"
            description="heading preferences.conf"
            defaultMessage={errorMessage}
          />
      </div>
    </>
  );
};
export const ResponseView: React.SFC <ResponseViewProps> = props => {
  const { response, onExit, adminConfig, clientConfig, customer, directViewLogin, emailAuthOnly, redeemGiftOnly } = props;
  let pageIntroTable = getAdminConfigTableItem(
    adminConfig,
    clientConfig,
    'PageIntro',
  );
  let pageIntro;
  if (pageIntroTable.PageIntroductions) {
    pageIntro = pageIntroTable.PageIntroductions.find(intro => {
      return intro.route === (emailAuthOnly ? 'email-auth' : (redeemGiftOnly ? 'redeemgift' : 'communication-prefs'));
    });
  }
  if (response && response.success) {
    let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
    if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
      pageIntroDescHtml[0].innerHTML = pageIntro ? (pageIntro.confDescription ? pageIntro.confDescription : pageIntro.description ) : '';
    }
  
    let pageHeadingLabelHtml = document.getElementsByClassName('page-intro-label') || null;
    if (pageHeadingLabelHtml && pageHeadingLabelHtml.length > 0) {
      pageHeadingLabelHtml[0].innerHTML = pageIntro ? pageIntro.label + ' Confirmation' : '';
    }
  }

  return (
    <div className="preferences-response-view">
      <Row>
        <Col xs={12} sm={12} md={12}>
          <div className="mt-4 mb-4">
            {response && response.success && <SuccessView redeemGiftOnly={redeemGiftOnly}/>}
            {response && !response.success && <ErrorView onReset={onExit}/>}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12}>
          {emailAuthOnly && response && response.success && (
            <>              
              <span>{customer.address.name}</span><br/>
              <span>Email Address: {customer.email} </span><br/>
              <span>Email Authorization: {customer.permissions.emailAuthorization === 'Y' ? 'Yes' : 'No'} </span><br/>
            </>
          ) }
          {!emailAuthOnly && response && response.success && (
            <ConfirmationDetail
              currentOrder={null}
              customer={customer}
            />
          )}
          {redeemGiftOnly && response && response.success && (
            <>              
              <span>Email Address: {customer.email} </span><br/>
              <span>Email Authorization: {customer.permissions.promoteByEmail === 'Y' ? 'Yes' : 'No'} </span><br/>
            </>
          ) }
        </Col>
      </Row>
      {!directViewLogin && (
        <Row className="mt-auto">
          <Col xs={12} sm={12} md={12}>
            <div className="d-flex justify-content-end mb-2 cancel-btn">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={onExit}
              >
                <FormattedMessage
                  id={'app.cancel'}
                  description={'close button text'}
                  defaultMessage={'Close'}
                />
              </button>
            </div>
          </Col>
        </Row>
      )}

    </div>
  );
};
